import { useDataBoxSelector } from 'app/common/data-box-store'
import { SendersInfo } from 'app/dataTypes/transfer/senders'

import { sendersInfo } from '../dataBox'


export function useSendersInfoData() {
  const data = useDataBoxSelector<SendersInfo>(sendersInfo, () => sendersInfo.data)
  return data
}
